module.exports = __webpack_public_path__ + "static/media/mos-teknorot.1f05f873.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/mos-teknorot.png
// module id = 282
// module chunks = 0